import { render, staticRenderFns } from "./RelatorioCheckInOutListRoute.vue?vue&type=template&id=132f10f0"
import script from "./RelatorioCheckInOutListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioCheckInOutListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports